<template>
  <div class="lk-notifications">
    <button type="button" class="lk-notifications__trigger" :aria-label="triggerAriaLabel" @click="handleTriggerClick">
      <span v-if="hasNotifications" class="lk-notifications__badge">
        {{ notificationsCountLabel }}
      </span>

      <BellSvg class="lk-notifications__icon"></BellSvg>
    </button>

    <div
      v-if="showDesktopDropdown"
      class="lk-notifications__dropdown"
      :class="{ 'lk-notifications__dropdown--fade': isGradientVisible }"
    >
      <div class="lk-notifications__dropdown-wrap">
        <div class="lk-notifications__dropdown-head">
          <div class="lk-notifications__dropdown-title">{{ notificationsCountLabel }} {{ $root.staticText.lk.notify }}</div>

          <router-link :to="{ name: 'lk-notifications' }" class="lk-notifications__all-link t-lk-link">
            <span>{{ $root.staticText.lk.notifyAll }}</span>
            <svg
              class="lk-notifications__arrow-right"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.8396 3.93238C5.60815 4.16383 5.60815 4.53908 5.8396 4.77053L9.56918 8.50011L5.8396 12.2297C5.60815 12.4611 5.60815 12.8364 5.8396 13.0678C6.07105 13.2993 6.44631 13.2993 6.67776 13.0678L10.8264 8.91918C11.0579 8.68774 11.0579 8.31248 10.8264 8.08103L6.67776 3.93238C6.44631 3.70093 6.07105 3.70093 5.8396 3.93238Z"
                fill="#00b0bd"
              />
            </svg>
          </router-link>
        </div>

        <div ref="dropdownContainer" class="lk-notifications__dropdown-container">
          <div v-for="item in notifications" :key="getNotificationKey(item)" class="lk-notifications__dropdown-item">
            <div class="lk-notifications__dropdown-row">
              <div class="lk-notifications__dropdown-tag">
                {{ item.tag }}
              </div>

              <div class="lk-notifications__dropdown-date">
                {{ item.date }}
                <svg
                  class="lk-notifications__dropdown-date-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.00013 2.53322C6.55028 2.53322 5.15981 3.10917 4.13461 4.13437C3.10941 5.15957 2.53346 6.55004 2.53346 7.99989C2.53346 8.71778 2.67486 9.42864 2.94959 10.0919C3.22431 10.7551 3.62699 11.3578 4.13461 11.8654C4.64224 12.373 5.24488 12.7757 5.90813 13.0504C6.57137 13.3252 7.28224 13.4666 8.00013 13.4666C8.71802 13.4666 9.42889 13.3252 10.0921 13.0504C10.7554 12.7757 11.358 12.373 11.8656 11.8654C12.3733 11.3578 12.7759 10.7551 13.0507 10.0919C13.3254 9.42864 13.4668 8.71778 13.4668 7.99989C13.4668 6.55004 12.8908 5.15957 11.8656 4.13437C10.8404 3.10917 9.44998 2.53322 8.00013 2.53322ZM3.38037 3.38012C4.6056 2.15488 6.26738 1.46655 8.00013 1.46655C9.73288 1.46655 11.3947 2.15488 12.6199 3.38012C13.8451 4.60536 14.5335 6.26714 14.5335 7.99989C14.5335 8.85786 14.3645 9.70742 14.0361 10.5001C13.7078 11.2927 13.2266 12.013 12.6199 12.6196C12.0132 13.2263 11.293 13.7076 10.5003 14.0359C9.70767 14.3642 8.8581 14.5332 8.00013 14.5332C7.14216 14.5332 6.29259 14.3642 5.49993 14.0359C4.70727 13.7076 3.98704 13.2263 3.38037 12.6196C2.77369 12.013 2.29245 11.2927 1.96412 10.5001C1.63579 9.70742 1.4668 8.85786 1.4668 7.99989C1.4668 6.26714 2.15513 4.60536 3.38037 3.38012ZM8.00013 4.79989C8.29468 4.79989 8.53346 5.03867 8.53346 5.33322V7.77897L10.3773 9.62276C10.5855 9.83104 10.5855 10.1687 10.3773 10.377C10.169 10.5853 9.83129 10.5853 9.62301 10.377L7.62301 8.37701C7.52299 8.27699 7.4668 8.14134 7.4668 7.99989V5.33322C7.4668 5.03867 7.70558 4.79989 8.00013 4.79989Z"
                    fill="#C0C0CC"
                  />
                </svg>
              </div>
            </div>

            <div class="lk-notifications__dropdown-name">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import BellSvg from '@assets/lk/icons/bell.svg?inline'

export default {
  name: 'LkNotifications',
  components: {
    BellSvg,
  },
  data() {
    return {
      isGradientVisible: true,
    }
  },
  computed: {
    ...mapGetters('lk', ['profile']),
    ...mapState('mobile', ['isLkMobile']),

    notifications() {
      return this.profile?.notifications ?? []
    },
    hasNotifications() {
      return this.notifications.length > 0
    },
    notificationsCountLabel() {
      if (!this.hasNotifications) return '0'
      return this.notifications.length > 99 ? '99+' : String(this.notifications.length)
    },
    showDesktopDropdown() {
      return this.hasNotifications && !this.isLkMobile
    },
    triggerAriaLabel() {
      return this.hasNotifications ? `Уведомления: ${this.notificationsCountLabel}` : 'Уведомления'
    },
  },
  mounted() {
    this.bindDropdownScroll()
  },
  updated() {
    this.bindDropdownScroll()
    this.updateGradientVisibility()
  },
  beforeDestroy() {
    this.unbindDropdownScroll()
  },
  methods: {
    ...mapActions('modal', ['modalType_lkMobileNotifyOpen']),

    handleTriggerClick() {
      if (this.isLkMobile) {
        if (this.hasNotifications) {
          this.modalType_lkMobileNotifyOpen({})
          return
        }

        this.$router.push({ name: 'lk-notifications' })
        return
      }

      this.$router.push({ name: 'lk-notifications' })
    },
    bindDropdownScroll() {
      const dropdown = this.$refs.dropdownContainer

      if (!dropdown || this._dropdownElement === dropdown) return

      this.unbindDropdownScroll()
      this._dropdownElement = dropdown
      this._dropdownElement.addEventListener('scroll', this.updateGradientVisibility)
      this.updateGradientVisibility()
    },
    unbindDropdownScroll() {
      if (!this._dropdownElement) return

      this._dropdownElement.removeEventListener('scroll', this.updateGradientVisibility)
      this._dropdownElement = null
    },
    updateGradientVisibility() {
      const dropdown = this.$refs.dropdownContainer
      if (!dropdown) return

      const scrollBottom = dropdown.scrollHeight - dropdown.clientHeight
      this.isGradientVisible = dropdown.scrollTop < scrollBottom
    },
    getNotificationKey(item) {
      return `${item?.tag || ''}-${item?.date || ''}-${item?.name || ''}`
    },
  },
}
</script>

<style lang="sass">
@import "~@src/assets/lk/styles/variables"

.lk-notifications
  position: relative
  display: flex
  align-items: center
  height: var(--header-bottom-height)

  &:hover
    .lk-notifications__dropdown
      opacity: 1
      transform: translateY(0)
      pointer-events: auto

  &__trigger
    position: relative
    display: inline-flex
    align-items: center
    justify-content: center
    padding: 0
    border: 0
    background: transparent
    border-radius: 6px
    cursor: pointer
    transition: background .3s, color .3s
    will-change: background, color

    &:hover
      color: $bright-blue

    @media (max-width: $header-screen-md)
      &:hover
        color: $white

  &__icon
    display: block

  &__badge
    position: absolute
    top: -8px
    left: calc(100% - 14px)
    min-width: 20px
    padding: 0 5px
    border-radius: 100px
    background: #f94f8c
    color: $white
    font-size: 14px
    font-weight: 600
    line-height: 20px

  &__dropdown
    position: absolute
    top: 100%
    right: -67px
    z-index: 1000
    width: 386px
    padding-top: 6px
    opacity: 0
    pointer-events: none
    transition: opacity .3s, transform .4s

    @media (min-width: $desktop-medium)
      width: 454px

    @media (max-width: $header-screen-md)
      right: 0
      padding-top: 6px

    @media (max-width: $header-screen-md)
      width: 100%

    &::after
      content: ''
      position: absolute
      left: 0
      bottom: 16px
      width: calc(100% - 10px)
      height: 92px
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)
      opacity: 0
      pointer-events: none
      transition: opacity .3s

    &--fade::after
      opacity: 1

  &__dropdown-wrap
    overflow: hidden
    border-radius: 6px
    background: #FFFFFF
    box-shadow: 0 4px 25px rgba(30, 37, 59, 0.15)

  &__dropdown-head
    display: flex
    align-items: center
    justify-content: space-between
    padding: 16px
    border-bottom: 1px solid #F5F5FA

    @media (min-width: $desktop-medium)
      padding: 24px

    @media (max-width: $header-screen-md)
      flex-direction: column
      align-items: flex-start
      padding: 0 0 16px

  &__dropdown-title
    color: #1E253B
    font-size: 16px
    line-height: 130%
    font-family: 'Proxima Nova Semi', sans-serif

    @media (max-width: $header-screen-md)
      margin-bottom: 8px
      font-size: 18px

  &__dropdown-container
    max-height: 320px
    margin: 16px 0
    padding: 0 16px
    overflow-y: auto
    overflow-x: hidden

    @media (min-width: $desktop-medium)
      max-height: 340px
      margin: 24px 0
      padding: 0 24px

    @media (max-width: $header-screen-md)
        width: calc(100% + 16px)
        margin-bottom: 0
        padding: 0 8px 0 0

  &__dropdown-item
    padding: 16px
    border-radius: 6px
    background: #F5F5FA

    &:not(:last-child)
      margin-bottom: 8px

  &__dropdown-row
    display: flex
    align-items: center
    justify-content: space-between
    margin-bottom: 8px

  &__dropdown-tag
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
    color: #C0C0CC
    font-size: 12px
    line-height: 130%

  &__dropdown-date
    display: flex
    align-items: center
    margin-left: 24px
    white-space: nowrap
    color: #C0C0CC
    font-size: 12px
    line-height: 130%

    @media (max-width: $header-screen-md)
      margin: 12px 0 0

  &__dropdown-date-icon
    display: block
    margin-left: 8px

  &__dropdown-tag, &__dropdown-date
    @media (min-width: $desktop-medium)
      font-size: 14px

  &__dropdown-name
    color: #293045
    font-family: 'Segoe UI', sans-serif
    font-size: 14px
    font-weight: 600
    line-height: 130%

    @media (min-width: $desktop-medium)
      font-size: 16px

  &__all-link
    margin-left: auto
    color: $gray-footer
    display: flex
    align-items: center
    font-size: 18px
    line-height: 110%
    cursor: pointer

    &:hover
      color: $green

      .lk-notifications__arrow-right
        transform: translateX(3px)
        fill: $green

    @media (min-width: $desktop-big)
      font-size: 24px

    @media (max-width: $tablet-size)
      font-size: 16px

    @media (max-width: $header-screen-md)
      margin-left: 0

  &__arrow-right
    width: 8px
    height: 16px
    margin: 2px 0 0 8px
    transition: transform .2s

    @media (min-width: $desktop-big)
      margin-left: 12px

    @media (max-width: $tablet-size)
      width: 6px
      height: 11px
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/lk/header/components/LkNotifications.vue